/* tslint:disable */
/* eslint-disable */
/**
 * crm-campaigns
 * crm-campaigns
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserName
 */
export interface UserName {
    /**
     * 
     * @type {string}
     * @memberof UserName
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserName
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof UserName
     */
    last_name: string;
}

/**
 * Check if a given object implements the UserName interface.
 */
export function instanceOfUserName(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;

    return isInstance;
}

export function UserNameFromJSON(json: any): UserName {
    return UserNameFromJSONTyped(json, false);
}

export function UserNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
    };
}

export function UserNameToJSON(value?: UserName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
    };
}

